/* eslint-disable max-len */
export const errors = {
  'service-is-unavailable': 'Xizmat vaqtincha ishlamayapti, keyinroq urining',
  'cannot-get-telegram-link': 'Telegram havolasi olinmadi',
  'maybe-error': 'Ehtimoliy xatolik',
  'check-email': 'Siz bilan aloqaga chiqishimiz uchun email manzilining toʻgʻriligini tekshiring.',
  'check-input-correctness': 'Xatosiz kiritilganini tekshiring!',
  'link-possibly-expired': 'Havolangiz eskirgan yoki andoza mavjud emas, shekilli. SM yordam xizmatiga murojaat qiling',
  'interview-has-already-been-recorded': 'Intervyu avvalroq yozib olingan',
  'use-are-using-outdated-browser': 'Afsuski, brauzeringiz zamonaviy texnologiyalarni dastaklamaydi va videoni yozib olish kabi ayrim funksiyalar ishlamasligi mumkin. Toʻgʻri ishlashi va maʼlumotlar aks etishi uchun Chrome, FireFox yoki Edge brauzerlaridan foydalaning.',
  'questionnaire-was-not-sent': 'Anketa yuborilmadi',
  'check-data-correctness': 'Kiritilgan maʼlumotlar xatosiz ekanini tekshiring.',
  error: 'Xatolik',
  'connot-load-questionnaire-template': 'Anketa andozasi yuklanmadi, yordam xizmatiga murojaat qiling.',
  'somthing-went-wrong-try-leter': 'Xatolik yuz berdi. Sahifani keyinroq ochishga urining.',
  'no-answer-was-sent': 'Javob yuborilmadi',
  'you-can-choose-only-one-variant': 'Faqat bitta variantni tanlash mumkin',
  'full-name-must-contain-three-words': 'FIO maydoni boʻsh joy bilan ajratilgan uchta soʻzdan iborat boʻlishi shart!',
  'phone-must-have-format': 'Telefon raqami +998 (NN) NNN-NNNN formatida boʻlishi shart!',
  'video-interview-has-already-been-created': 'Video intervyu avvalroq yaratilgan, intervyu topshiring.',
};
